export class AnnotatorResult {

    public id:string;

    public label:string;

    public ontologyAcronym:string;
}